import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { cloneDeep, findIndex } from 'lodash';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Enums } from '../../../../../../../configs/Enums';
import { BrigadesService } from '../../brigades.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-merge-brigade-modal',
  templateUrl: './merge-brigade-modal.component.html',
  styleUrls: ['./merge-brigade-modal.component.scss'],
  standalone: false,
})
export class MergeBrigadeModalComponent implements OnInit {
  public brigadesList;
  public brigadeSelected;
  public brigadesWithOutSelected;
  public mergeBrigadeLoading = false;
  public errorMessage = null;

  constructor(
    private brigadesService: BrigadesService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.onChangeSelectedBrigade(this.brigadesList[0]);
  }

  public onChangeSelectedBrigade(brigade) {
    let brigadeIndex = findIndex(this.brigadesList, { id: brigade.id });

    this.brigadeSelected = brigade;

    if (brigadeIndex > -1) {
      let brigades = cloneDeep(this.brigadesList);
      brigades.splice(brigadeIndex, 1);
      this.brigadesWithOutSelected = brigades;
    }
  }

  public onMergeBrigades() {
    let brigade_ids = this.brigadesWithOutSelected.map((brigade) => brigade.id);
    brigade_ids.push(this.brigadeSelected.id);
    this.mergeBrigadeLoading = true;
    this.brigadesService
      .brigadesMerge({
        brigade_ids: brigade_ids,
        dest: this.brigadeSelected.id,
      })
      .subscribe(
        (response) => {
          this.activeModal.close();
          this.mergeBrigadeLoading = false;
        },
        (error) => {
          this.errorMessage = Enums.errorCodes[Enums.errorCodesMaps['BACKEND_ERROR']];
          this.mergeBrigadeLoading = false;
        }
      );
  }
}
